import { useState } from 'react';

/**
 * Hook for measuring elapsed time between events (in seconds)
 */
export function useTimeMeasurement() {
  const [startTime, setStartTime] = useState<number>();

  const start = () => setStartTime(Date.now());
  const stop = () => {
    const durationSeconds = startTime
      ? (Date.now() - startTime) / 1000
      : undefined;
    setStartTime(undefined);
    return durationSeconds;
  };

  return { start, stop };
}
